



















































































































































































































































import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import Video from "@/components/Video.vue";
import {
  BIcon,
  BIconBoxArrowRight,
  BIconUpload,
  BButton,
  BModal,
} from "bootstrap-vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    Header,
    Menu,
    Video,
    BIcon,
    BIconBoxArrowRight,
    BIconUpload,
    BButton,
    BModal,
    NextPrevBtn,
    Footer,
  },
})
export default class SpeechTips extends Vue {
  protected videoSpeech = [
    {
      videoSrc: "https://www.youtube.com/embed/wkOk1wdTdrQ ",
      videoTitle: "L’art de bien parler",
      videoRoot: "Chaîne : Evolution Factory",
    },
    {
      videoSrc: "https://www.youtube.com/embed/IDZGAbCY_Zw",
      videoTitle: "Comment bien communiquer en public",
      videoRoot: "Chaîne : Jean Sommer Coach Vocal ",
    },
    {
      videoSrc: "https://www.youtube.com/embed/DM5rrmigZZU",
      videoTitle: "Les secrets d’une intervention orale réussie",
      videoRoot: "Chaîne : DunodVideos",
    },
    {
      videoSrc: "https://www.youtube.com/embed/um2TfrSGJ7o",
      videoTitle: "7 astuces pour bien parler en public",
      videoRoot: "Chaîne : Cyril Chambard",
    },

    {
      videoSrc: "https://www.youtube.com/embed/6JG4_6sUPvg",
      videoTitle: "Comment bien accrocher son auditoire ?",
      videoRoot: "Chaîne : Cyril Chambard",
    },
    {
      videoSrc: "https://www.youtube.com/embed/kk0yINlr2ro",
      videoTitle:
        "Quand prendre la parole devient un jeu : concours d’éloquence HEC 1",
      videoRoot: "Chaîne : HEC Paris",
    },
    {
      videoSrc: "https://www.youtube.com/embed/x8mGosE1zH4",
      videoTitle:
        "Quand prendre la parole devient un jeu : concours d’éloquence HEC 2",
      videoRoot: "Chaîne : HEC Paris",
    },
  ];
  protected videoSpeechFear = [
    {
      videoSrc: "https://www.youtube.com/embed/nFsrdpVn85s",
      videoTitle: "Comment vaincre la peur de parler en public : 9 astuces puissantes pour captiver ton audience",
      videoRoot: "Chaîne : LA SAGESSE DE L'ENCRE",
    },
    {
      videoSrc: "https://www.youtube.com/embed/YbhOsZtWuMY",
      videoTitle: "Comment vaincre la peur de parler en public 2",
      videoRoot: "Chaîne : Cyril Chambard",
    },
    {
      videoSrc: "https://www.youtube.com/embed/zApHS2LJxIk",
      videoTitle: "Comment parler en public sans stress ?",
      videoRoot: "Chaîne : Français avec Pierre",
    },
  ];
  protected nxtprevSpeechTips = {
    BoolPrev: true,
    BoolNext: false,
    PrevImage: "/thumbnail4.png",
    NextImage: "",
    PrevLink: "/Prise_de_Parole/Parametre_Parole",
    NextLink: "",
  };
}
